module.exports = __webpack_public_path__ + "img/img6.9de8e6bf.svg";